module.exports = __webpack_public_path__ + "media/images/application/template/logo-google-reviews-alt-dbe88d622e601043d2d3b746717ce3f4.svg";